import { APP_STORE_ANDROID_URL, APP_STORE_APPLE_URL } from './appStores';
import { CONTACT_EMAIL, INSTAGRAM_URL } from './contact';

export const SITE_NAME = 'Ufokko';

export const DEFAULT_TITLE = 'Contratar videomaker perto de você | Ufokko';

export const DEFAULT_DESCRIPTION =
  'Contrate videomakers perto de você com pagamento em escrow. Publique jobs no app, aprove entregas e pague com segurança. Disponível na App Store e Google Play.';

/** Imagem social 1200×630 recomendada; usar logo até arte dedicada existir. */
export const DEFAULT_OG_IMAGE = '/logo/ufokko-logo-azul.png';

export const PUBLIC_SITE_URL_FALLBACK = 'https://ufokko.com.br';

export const SAME_AS_LINKS = [
  INSTAGRAM_URL,
  APP_STORE_APPLE_URL,
  APP_STORE_ANDROID_URL,
].filter(Boolean);

export const ORGANIZATION_CONTACT = {
  '@type': 'ContactPoint',
  contactType: 'customer support',
  email: CONTACT_EMAIL,
  availableLanguage: ['Portuguese'],
  areaServed: 'BR',
};
